<template>
    <div class="section-member">
        <div class="section-member-fixed">
            <a href="javascript:void(0)" 
                :class="{'active':curActiveChar==''}"
                @click="setChar('',index)">
                {{t('selectMember.all')}}
            </a>
            <a href="javascript:void(0)" 
                :class="{'active':curActiveChar==String.fromCharCode(64+num)}"
                @click="setChar(String.fromCharCode(64+num), index)"
                v-for="(num, index) in 26" :key="index">{{String.fromCharCode(64+num)}}</a>
        </div>
        <div class="scroll-content-horizonal" ref="scrollContent">
            <MemberNode 
                v-for="(item, index) in list"
                :key="index"
                :data="item"
                @handleChecked="handleChecked" />
            <Load 
                :hasData="!!list.length"
                :hasMore="hasMore"
                :loading="loading" 
                @on-load="getMemberList"/>
            <Empty v-if="!loading && !hasMore && !list.length"/>
        </div>
    </div>
</template>
<script>
    import MemberNode from './section-member-node'
    import scroll from '../mixins/scroll'
    import section from '../mixins/section'
    import ajax from '../../../../utils/ajax'
    import Load from '../../../base/page/'
    import Empty from '../../../base/empty/'
    import Locale from '../../../../mixins/locale'

    export default {
        name: 'SectionMember',
        mixins: [scroll, section, Locale],
        inject: ['root'],
        data() {
            return {
                curActiveChar: ''
            }
        },
        components: {
            MemberNode,
            Load,
            Empty
        },
        methods: {
            getMemberList(params) { // 拉取当前组织树
                const _this = this
                this.loading = true
                const deptIds = this.root.deptList && this.root.deptList.map((item)=>{
                    return item.deptId
                }) || []
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/members`,
                    params: {
                        page: _this.page,
                        size: _this.size,
                        keyword: _this.root.keyword || '',
                        firstLetter: _this.curActiveChar,
                        deptIds: [...deptIds],
                        type: _this.root.chooseType,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            return _this.handleError()
                        }

                        data.forEach(item => {
                            item.checked = false
                        })
                        _this.hasMore = !(data.length < _this.size)
                        _this.page++
                        _this.loading = false
                        return _this.list = (_this.list || []).concat(data)
                    },
                    error() {
                        _this.handleError()
                    }
                })
            },
            initMemberList() {
                this.page = 1
                this.list = []
                this.hasMore = true
                this.updateScroll()
            },
            setChar(chara) {
                this.curActiveChar = chara
                this.initMemberList()
                this.getMemberList()
            }
        },
        created() {
            this.getMemberList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/select-member/section/section-member.vue